import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContainerContext } from '../../../../../context/ContainerContext';
import {
  ContainerMutations,
  DeleteContainerResponse,
  DeleteContainerVariables,
} from '../../../../../graphql/container.graphql';
import useMutation from '../../../../../hooks/useMutation';
import { useToast } from '../../../../../providers/ToastProvider';
import { Container, ContainerInput } from '../../../../../types/container';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { Routing } from '../../../../../util/routes.util';
import { CancelButton, ButtonVariant, Button } from '../../../../components/Button';
import { AlertModal } from '../../../../components/Modal';
import { ToastType } from '../../../../components/Toast';

interface ContainerDeleteModalProps {
  container: Container;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function ContainerDeleteModal({ container, open, setOpen }: ContainerDeleteModalProps) {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const { containers, setContainers } = useContext(ContainerContext);

  const [remove, { loading }] = useMutation<DeleteContainerResponse, DeleteContainerVariables>(
    ContainerMutations.remove,
    {
      variables: { containers: [new ContainerInput(container).forDelete()] },
      onCompleted: response => {
        containers.delete(response.deleteContainer[0].id);
        setContainers(new Map(containers));
        showToast({
          type: ToastType.success,
          title: translate({ key: TranslationKey.containerDeletedSuccessfullyToastTitle }),
        });
        setOpen(false);
        navigate(Routing.stock.containers.overview());
      },
    },
  );

  return (
    <AlertModal title={translate({ key: TranslationKey.deleteContainerModalTitle })} open={open} setOpen={setOpen}>
      <div className='grid gap-4'>
        <p className='subtitle'>{translate({ key: TranslationKey.deleteContainerModalSubtitle })}</p>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <Button
            variant={ButtonVariant.danger}
            text={translate({ key: TranslationKey.deleteContainer })}
            onClick={() => remove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
